import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { PushTopic } from "@seneca/notifications-service-types";
import { Expose } from "@seneca/small-utils-library";

import { getUserId } from "seneca-common/features/user/state";

import { analyticsLogUserClickedOnPushNotification } from "../";
import { NotificationType } from "../consts";

type Props = Expose<{
  pushSource?: PushTopic | null;
  notificationType: NotificationType | null;
}>;

const PUSH_SOURCE_MAX_LENGTH = 30;

export default function usePushNotificationsAnalytics(props: Props) {
  const userId = useSelector(getUserId);
  const { source } = useGetCachedProps(props);
  const [hasLogged, setHasLogged] = useState(false);

  useEffect(() => {
    if (userId && source && !hasLogged) {
      analyticsLogUserClickedOnPushNotification(source);
      setHasLogged(true);
    }
  }, [source, userId, hasLogged]);
}

function useGetCachedProps({ pushSource, notificationType }: Props) {
  const isPush = notificationType === NotificationType.PUSH;

  const [source, setSource] = useState<PushTopic>();

  useEffect(() => {
    if (isPush && pushSource && pushSource.length <= PUSH_SOURCE_MAX_LENGTH)
      setSource(pushSource);
  }, [isPush, pushSource]);

  return { source };
}
